import { useEffect, useState } from 'react';

// A piece of page state the browser remembers, under the key given. The old
// dashboard kept every filter this way — which pods, which channels, which
// window — so coming back to the Director's page put you where you left it
// rather than on all pods, today vs MTD, every time.
//
// Keys are per view (`director.selectedPods`), because the same person looks
// at the Director's floor and a supervisor's pod for different reasons.
//
// Storage can throw — a private window, blocked site data — and a filter is
// not worth failing a page over, so both sides are guarded and the fallback
// is simply the default.
export default function usePersisted(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved !== null) return JSON.parse(saved);
    } catch { /* fall through to the default */ }
    return typeof initial === 'function' ? initial() : initial;
  });
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* not worth failing over */ }
  }, [key, value]);
  return [value, setValue];
}

/** Whether this key has ever been written — a remembered choice beats a default. */
export function wasPersisted(key) {
  try { return localStorage.getItem(key) !== null; } catch { return false; }
}
